var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#back_arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.266.47a1.598 1.598 0 0 0-2.264 0L5.374 11.098a1.274 1.274 0 0 0 0 1.804L16.002 23.53a1.598 1.598 0 0 0 2.264 0 1.598 1.598 0 0 0 0-2.264l-9.26-9.272L18.28 2.72A1.594 1.594 0 0 0 18.266.47Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "back_arrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBackArrow;